import React from 'react'
import { Editor } from 'super-charged-rte'
export default React.memo((props) => {
  return (
    <Editor
      {...props}
    />
  )
}, (prevProps, nextProps) => {
  return prevProps.isloading === nextProps.isloading && prevProps.selectedPage === nextProps.selectedPage
})
